import script from "./SendTestEmailDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendTestEmailDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SendTestEmailDialog.vue?vue&type=style&index=0&id=1b38e340&scoped=true&lang=css"
import "./SendTestEmailDialog.vue?vue&type=style&index=1&id=1b38e340&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b38e340"]])

export default __exports__